import { HOTEL_STRUCTURE_TYPES } from '../constants';

export const isMultiPropertiesHotel = (hotelGroupInfo) => {
  try {
    return hotelGroupInfo?.structure === HOTEL_STRUCTURE_TYPES.MULTIPLE_PROPERTIES;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const isGroupOfHotels = (hotelGroupInfo) => {
  try {
    return hotelGroupInfo?.structure === HOTEL_STRUCTURE_TYPES.GROUP;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const isSingleHotel = (hotelGroupInfo) => {
  try {
    return hotelGroupInfo?.structure === HOTEL_STRUCTURE_TYPES.SINGLE;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const getRGB = (hex) => {
  hex = hex.trim().replace("#", "");
  if (hex.length !== 6) {
    hex = hex.slice(0, 3).replace(/(.)/g, '$1$1');
  }
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return [r, g, b];
};

export const hexToRGBA = (hex, opacity = '1') => {
  const rgba = [...getRGB(hex), opacity].join(', ');
  return `rgba(${rgba})`;
};

export const deepMerge = (base, ...sources) => {
  const result = { ...base };

  if (!sources?.length) {
    return result;
  }

  const overrides = sources.shift();

  for (const key in overrides) {
    if (overrides.hasOwnProperty(key)) {
      // If both values are objects, recursively merge them
      if (
        typeof overrides[key] === 'object' && 
        overrides[key] !== null &&
        !Array.isArray(overrides[key]) &&
        base[key] && 
        typeof base[key] === 'object'
      ) {
        result[key] = deepMerge(base[key], overrides[key]);
      } else {
        // Otherwise, use the override value
        result[key] = overrides[key];
      }
    }
  }

  return deepMerge(result, ...sources);
};
